import React, { useState } from 'react';

/*
  Reusable Odoo-style kanban board with drag-to-change-column.
  props:
    columns: [{ value, label, color? }]   — the stages (e.g. planning/active/completed)
    groupField                             — record field that maps to a column value (e.g. 'status')
    records: array
    getKey(record)
    onCardClick(record)
    renderCard(record)                     — JSX for the card body
    onMove(record, newValue)               — called when a card is dropped in a new column
    canMove                                — boolean (permission)
*/
export default function OdooKanban({ columns, groupField, records, getKey, onCardClick, renderCard, onMove, canMove = true }) {
  const [dragId, setDragId] = useState(null);
  const [overCol, setOverCol] = useState(null);

  const byCol = {};
  columns.forEach((c) => { byCol[c.value] = []; });
  (records || []).forEach((r) => {
    const v = r[groupField];
    if (byCol[v]) byCol[v].push(r); else (byCol[columns[0].value] = byCol[columns[0].value] || []).push(r);
  });

  function onDrop(colValue) {
    setOverCol(null);
    const rec = (records || []).find((r) => String(getKey(r)) === String(dragId));
    setDragId(null);
    if (rec && rec[groupField] !== colValue && onMove) onMove(rec, colValue);
  }

  return (
    <div className="okb">
      {columns.map((col) => (
        <div key={col.value}
          className={'okb-col' + (overCol === col.value ? ' over' : '')}
          onDragOver={(e) => { if (canMove) { e.preventDefault(); setOverCol(col.value); } }}
          onDragLeave={() => setOverCol((c) => (c === col.value ? null : c))}
          onDrop={() => canMove && onDrop(col.value)}>
          <div className="okb-colhead">
            <span className="okb-dot" style={{ background: col.color || '#8A93A3' }} />
            <span className="okb-collabel">{col.label}</span>
            <span className="okb-colcount">{byCol[col.value].length}</span>
          </div>
          <div className="okb-cards">
            {byCol[col.value].length === 0 && <div className="okb-empty">No records</div>}
            {byCol[col.value].map((r) => (
              <div key={getKey(r)}
                className={'okb-card' + (String(dragId) === String(getKey(r)) ? ' dragging' : '')}
                draggable={canMove}
                onDragStart={() => setDragId(getKey(r))}
                onDragEnd={() => { setDragId(null); setOverCol(null); }}
                onClick={() => onCardClick && onCardClick(r)}>
                {renderCard(r)}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
